export default {"src":"/_next/static/media/kr.876aeb6b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};